import { Component, inject, OnInit } from "@angular/core";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { UserStorageService } from "../../../services/user-storage.service";

@Component({
	selector: "app-surveynoreport",
	templateUrl: "./surveynoreport.component.html",
	styleUrls: ["./surveynoreport.component.scss"],
	imports: [TranslatePipe],
})
export class SurveynoreportComponent implements OnInit {
	public translate: TranslateService;
	public userservice: UserStorageService;

	constructor() {
		const translate = inject(TranslateService);
		const userService = inject(UserStorageService);

		this.translate = translate;
		this.userservice = userService;
	}

	ngOnInit(): void {
		const lang = this.userservice.getLanguage();
		this.translate.use(lang.shortcode);
	}
}
